import React from 'react';
import { cn } from '../../lib/classNames';
import { pageSubtitle, pageTitle } from '../../lib/uiClasses';

export const PageHeader = ({ title, description, actions, className }) => (
  <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between', className)}>
    <div>
      <h1 className={pageTitle}>{title}</h1>
      {description && <p className={pageSubtitle}>{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
